import React, { useState, useEffect, memo, useMemo } from 'react';
import OutageTeamNotes from '../OutageTeamNotes';
import LoadCustomerAlerts from '../CustomerAlerts/LoadCustomerAlerts';

export default function OutageHeader({ setViewoption, viewOption, options }) {
    // const options = [
    //     { title: 'CHAMADOS', opt: 'dashboard' },
    //     { title: 'RELATÓRIOS', opt: 'dashboard' },
    //     { title: 'ALERTAS CLIENTES', opt: 'dashboard' },
    //     { title: 'CAIXA DE E-MAIL', opt: 'dashboard' },
    //     { title: 'AVISOS', opt: 'dashboard' },
    // ]

    return (
        <div className='card' style={{ width: '100%', flexDirection: 'row', padding: 10, alignItems: 'flex-start' }}>
            <div style={{ display: 'flex', flexDirection: 'column', width: 'calc(100% - 70px)' }}>
                <span style={{ fontSize: '1.8em', fontWeight: 'bold' }}>OUTAGES</span>
                <div style={{ width: '100%', marginTop: 20, flexDirection: 'row', alignItems: 'flex-start', position: 'relative' }}>
                    {
                        options.map(el => (
                            <span
                                style={
                                    viewOption === el.opt
                                        ?
                                        { fontSize: '1.4em', fontWeight: 'bold', textDecoration: 'underline', textDecorationThickness: '0.2em', cursor: 'pointer' }
                                        :
                                        { fontSize: '1.4em', fontWeight: 'bold', cursor: 'pointer' }
                                }
                                onClick={() => { setViewoption(el.opt) }}
                            >
                                {el.title}
                            </span>
                        ))
                    }

                    <LoadCustomerAlerts showLabel={true} viewOption={viewOption} setViewoption={setViewoption} />
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'center', height: '100%' }}>
                <OutageTeamNotes />
            </div>
        </div>
    )
}